import { TFunction } from "i18next";
import { ICourse } from "redux/reducers/models/facility";
import { convertHoles } from "helpers/Helpers";

export const playerOptions = (t: TFunction, allowSingleBookings?: boolean, maxBookingSize: number = 4) => {
  const options = [];
  const displayLimit = Math.max(1, maxBookingSize);

  for (let i = 1; i <= displayLimit; i++) {
    options.push({
      value: String(i),
      title: String(i),
      disabled: i === 1 && allowSingleBookings ? true : false,
    });
  }
  options.push({ value: "any", title: t("Any"), disabled: false });
  return options;
};

export const holeOptions = (t: TFunction, course: ICourse) => [
  { value: "9", title: String(convertHoles(9, course)), disabled: false },
  { value: "18", title: String(convertHoles(18, course)), disabled: false },
  { value: "any", title: t("Any"), disabled: false },
];

export const cartOptions = (t: TFunction) => [
  { value: "yes", title: t("Yes"), disabled: false },
  { value: "no", title: t("No"), disabled: false },
  { value: "any", title: t("Any"), disabled: false },
];

type TPromotionTeeTime = {
  promotion_type?: "percent" | "amount" | null;
  promotion_value?: number | null;
  promotion_label?: string | null;
};

/** Name shared by every promoted tee time of the day, null when they differ or are unnamed. */
export const promotionFilterName = (teeTimes: TPromotionTeeTime[]) => {
  const promotedTeeTimes = (teeTimes ?? []).filter(
    teeTime => Boolean(teeTime?.promotion_type) && teeTime?.promotion_value != null,
  );

  if (promotedTeeTimes.length === 0) {
    return null;
  }

  const names = new Set(promotedTeeTimes.map(teeTime => teeTime?.promotion_label?.trim() || ""));
  const [name] = [...names];

  return names.size === 1 && name !== "" ? name : null;
};

export const promotionOptions = (t: TFunction, promotionName?: string | null) => [
  { value: "yes", title: promotionName || t("Promotions Only"), disabled: false },
  { value: "any", title: t("All"), disabled: false },
];
